import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumTransactionType implements BaseEnumType {
  private static allValues: EnumTransactionType[] = []; // make sure this is top-most
  
  public static credit = new EnumTransactionType(-1, "Credit", "enum_transaction_type_credit");
  public static order = new EnumTransactionType(1, "Order", "enum_transaction_type_order");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumTransactionType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isCredit() { return this === EnumTransactionType.credit; }
  public isOrder() { return this === EnumTransactionType.order; }

  public static getValues(): readonly EnumTransactionType[] {
    return EnumTransactionType.allValues;
  }

  public static getValuesExcept0(): readonly EnumTransactionType[] {
    return EnumTransactionType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumTransactionType {
    const found = EnumTransactionType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumTransactionType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumTransactionType): EnumTransactionType {
    const found = name ? EnumTransactionType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumTransactionType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumTransactionType>): boolean {
    return this.key === other?.key;
  }
}